$( document ).ready(function() {

  // read more button js in blog page 
  $(".read_more_btn").click(function() {
    if ($(this).hasClass("active_button")) {
      $(this).find("span").html("Indlæs flere");
    } else {
      $(this).find("span").html("Indlæs mindre");
    }
    $(this).toggleClass("active_button");
    $(this).parents(".article--content_wrapper").find(".article--content").toggleClass("active_content");
  });

  // hero Slider Slider js (Announcement Bar)
  $(".hero_banner_slider").slick({
    slidesToShow: 1,
    infinite:true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    arrows: false,
    pauseOnHover:true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    responsive: [
        {
          breakpoint: 767,
          settings: {
             dots: false,
          }
        },
      ]
   });

  // Product page Thumbnail Slider js (Product Thumbnail slider)
  $(".thumbnail-list_slick_slider").slick({
    slidesToShow: 4,
    infinite:false,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    dots: false,
    arrows: false,
    touchMove: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });

  
  // cart drawer recomanded Product Slider js (Cart Drawer)
  // pc--custom.js
  window.initSlickSlider = function() {
    var $sliderWrapper = $(".carddrawer-related-wrapper");
    if (!$sliderWrapper.hasClass('slick-initialized')) {
      $sliderWrapper.slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding: '150px',
        responsive: [
          {
            breakpoint: 575,
            settings: {
              centerPadding: '80px',
            }
          },
        ]
      });
    }
  };
  
  // Optionally run it immediately if needed:
  window.initSlickSlider();


  // Single Row Slider js (Announcement Bar)
  $(".row-slider-wrapper").slick({
    slidesToShow: 1,
    infinite:true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    dots: false,
    arrows: false
  });

  // footer section accrodian js
  if ($(window).width() < 991) {
    $('.footer_menu-wrapper_outer').find('.footer-block__details-content, .footer_menu-content').hide();
    $('.footer_menu-wrapper_outer h3').on('click', function(){
      $('.footer_menu-wrapper_outer').find('.footer-block__details-content, .footer_menu-content').slideUp();
      if($(this).nextAll().is(':hidden')) {
        $(this).nextAll().slideDown();
      }
    });
  };

  $(".product-form__quantity, .product_addto_btn").wrapAll( "<div class='quantity_selector_row' />");


  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  
  });

  // newsletter section scroll animation
  $('.footer_menu-wrapper_outer.block--link_list.menu__title--om-xo-handcraft .footer_menu-content p:last-child a').on('click', function(e) {
    e.preventDefault(); // Prevent the default action of the anchor tag click event
    var targetId = $(this).attr('href').substring(1); // Remove leading '#'
    var target = $('#' + targetId);
    if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top - 200
        }, 500); // Adjust the animation duration as per your requirement (500 milliseconds in this example)
    }
  });

   $('#countries').on('change', function(e) {
        e.preventDefault();
        var selectedValue = $(this).val();
        console.log('Selected value:', selectedValue);
        var disha = $('.contact_country_inner').val(selectedValue);
       console.log('Selected value:', disha);
    });


  $(".article--title--kaerlighed-til-papmache #MainContent .shopify-section, .article--title--newshandvaerket-gar-i-arv #MainContent .shopify-section").each(function(index) {
    $(this).addClass("forloop-index-" + (index + 1));
  });

  $(".article--title--newskaerlighed-til-papmache #MainContent .shopify-section").each(function(index) {
    $(this).addClass("forloop-index-" + (index + 1));
  });
  $(".article--title--newshandvaerket-gar-i-arv #MainContent .shopify-section, .article--title--newsvi-skal-respektere-og-passe-pa-hinanden-og-vores-lille-klode-new #MainContent .shopify-section").each(function(index) {
    $(this).addClass("forloop-index-" + (index + 1));
  });
  $(".page---about-us #MainContent .shopify-section").each(function(index) {
    $(this).addClass("forloop-index-" + (index + 1));
  });


  // presse-samarbejde section image filter js
  function showCategory(category) {
        // Get all image items
        var items = document.querySelectorAll('.image-item');

        // Loop through the items and show/hide based on the category
        items.forEach(function (item) {
            if (category === 'all') {
                item.style.display = 'block'; // Show all items
            } else if (item.classList.contains(category)) {
                item.style.display = 'block'; // Show items matching the category
            } else {
                item.style.display = 'none'; // Hide items that don't match
            }
        });
    }
    // Initially display all items
    document.addEventListener("DOMContentLoaded", function () {
        showCategory('all');
    });

});



// 15-04-2025
